import LanguagePage from "./LanguagePage";

export default LanguagePage;